interface TrustBilling {
  billClient?: boolean | null;
  evergreen?: number | null;
  trust?: { account?: { id?: string | null } | null } | null;
}

interface BillingOwner {
  billing?: TrustBilling | null;
}

export interface ResolvedTrustBilling {
  trustAccountId: string | null;
  evergreen: number | null;
}

// Same record next-backend's PayFromTrust draws from (and MemoProvider describes), with no
// fallback to the other level, so the editor's trust memo matches the saved one.
export function resolveTrustBilling(
  client: BillingOwner | null | undefined,
  matter: BillingOwner | null | undefined,
): ResolvedTrustBilling {
  const billing = client?.billing?.billClient
    ? client.billing
    : matter?.billing;

  return {
    trustAccountId: billing?.trust?.account?.id || null,
    evergreen: billing?.evergreen ?? null,
  };
}
